import graphql from "babel-plugin-relay/macro";
import { Image } from "react-native";
import { useFragment } from "react-relay";

import { CurrentClubWeather } from "@/components/CurrentClubWeather";
import { FacilityLogoSideNav } from "@/features/Session/components/FacilityLogo/FacilityLogoSideNav";
import {
  VStack,
  Text,
  Box,
} from "@whoosh/design-system/src/components/primitive";
import { getFill } from "@whoosh/utilities/src/Cloudinary";

import { HomeHeaderFragment_session$key } from "./__generated__/HomeHeaderFragment_session.graphql";
import { BookButtonHomeHeader } from "./components/BookButtonHomeHeader";

const NAV_IMAGE_ID = "nav-image_b4yfml.png";

type HomeHeaderProps = {
  sessionRef: HomeHeaderFragment_session$key | null;
  showBookNowButton?: boolean;
};

export const HomeHeader = ({
  sessionRef,
  showBookNowButton,
}: HomeHeaderProps) => {
  const session = useFragment(HomeHeaderFragmentString, sessionRef) || null;
  const club = session?.currentClientProfile?.member?.club;

  const currentClubBG = club?.appCustomization?.backgroundImage?.publicId;

  const navImage = getFill(
    currentClubBG ? currentClubBG : NAV_IMAGE_ID,
    1400,
    933
  )?.toURL();

  return (
    <VStack
      borderRadius={"4"}
      overflow="hidden"
      shadowOffset={{ width: 0, height: 17 }}
      shadowOpacity={0.08}
      shadowRadius={40}
      borderWidth={1}
      borderColor="outline-default"
    >
      <Image
        accessible={false}
        source={{ uri: navImage }}
        style={{ width: "100%", height: 120 }}
        resizeMode="cover"
      />
      <Box
        position="relative"
        top={-33}
        alignItems="center"
        style={{ marginBottom: -28 }}
      >
        <Box
          borderRadius={"2"}
          overflow="hidden"
          borderWidth={2}
          borderColor="surface-primary"
          backgroundColor="surface-primary"
          testID="home-header-club-logo-surface"
        >
          <FacilityLogoSideNav
            clubRef={session?.currentClientProfile?.member?.club || null}
          />
        </Box>
      </Box>
      <VStack paddingHorizontal={4} paddingBottom={4} alignItems="center">
        <VStack alignItems="center" gap={1} marginBottom={4}>
          <Text variant="mainHeading">
            {session?.currentClientProfile?.member?.club?.name}
          </Text>
          <CurrentClubWeather showMinimal />
        </VStack>
        {showBookNowButton ? (
          <BookButtonHomeHeader sessionRef={session ?? null} />
        ) : null}
      </VStack>
    </VStack>
  );
};

export const HomeHeaderFragmentString = graphql`
  fragment HomeHeaderFragment_session on Session {
    ...BookButtonHomeHeader_session
    currentClientProfile {
      member {
        club {
          id
          name
          ...FacilityLogoSideNavFragment_club
          appCustomization {
            backgroundImage {
              # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
              publicId: renderingKey
            }
          }
        }
      }
    }
  }
`;
